import { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { slideIn } from '../utils/motion';
import emailjs from 'emailjs-com';
import EarthCanvas from '../3d/Earth';
import StarsCanvas from '../3d/Stars';
import './Contact.css'

const Alert = ({ message, type, show, onClose }) => {
  if (!show) return null;

  let alertColor = "bg-blue-100 border-blue-500 text-blue-700";
  if (type === "error") {
    alertColor = "bg-red-100 border-red-500 text-red-700";
  } else if (type === "success") {
    alertColor = "bg-green-100  border-green-500 text-green-700";
  }

  return (
    <div className={`border-l-4 p-4 ${alertColor} rounded-md`} role="alert">
      <div className="flex justify-between">
        <p>{message}</p>
        <button onClick={onClose} className="text-lg font-bold">x</button>
      </div>
    </div>
  );
};

const Contact = () => {
  const formRef = useRef();
  const [form, setForm] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    message: '',
    type: '',
    show: false
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs.send('service_deumodk', 'template_v4v4y1c', {
      from_name: form.name,
      to_name: 'Amine Ajouhade',
      from_email: form.email,
      to_email: 'developerwebaj@gmail.com',
      message: form.message,
    }, 'Z4UAvJoBTa17XJIdd')
    .then(() => {
      setLoading(false);
      setAlert({
        message: 'Thank you. I will get back to you as soon as possible.',
        type: 'success',
        show: true
      });
      setForm({
        name: '',
        email: '',
        message: '',
      });
    }, (error) => {
      setLoading(false);
      console.log(error);
      setAlert({
        message: 'Something went wrong. Please try again later.',
        type: 'error',
        show: true
      });
    });
  };

  const textVariant = () => {
    return {
      hidden: { opacity: 0, y: -50 },
      visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
    };
  };

  return (
    <>
      <section className='relative w-full h-[90%] mx-auto bg-cover bg-center' id='contact'>
        

        <motion.div
        initial={{opacity:0.2,y:50}}
        transition={{duration:1}}
        whileInView={{opacity:1,y:0}}
        viewport={{once:true}}
          
          className="flex flex-col items-center justify-center text-center"
        >
          <h2 className="text-black text-[69px] font-bold">Interested in working <span className='text-[#fff000]'> together?</span></h2>
        </motion.div>

        <div className=''>
          <motion.div
            variants={slideIn('left', 'tween', 0.2, 1)}
            className='w-[60%] p-8 rounded-2xl'
          >
            {/* Alert Component */}
            

           
           
<div className="form-container">
<Alert 
              message={alert.message}
              type={alert.type}
              show={alert.show}
              onClose={() => setAlert({ ...alert, show: false })}
            />
     <form className="form" ref={formRef} onSubmit={handleSubmit}>
  <div className="form-group">
    <label htmlFor="name">Name</label>
    <input 
      type="text" 
      id="name" 
      className="name"  
      name="name" 
      value={form.name}
      onChange={handleChange} 
      placeholder="Write your Name" 
      required 
    />
  </div>

  <div className="form-group">
    <label htmlFor="email">Email</label>
    <input 
      type="email" 
      id="email" 
      className="email" 
      name="email"
      value={form.email}
      onChange={handleChange} 
      placeholder="Write your Email" 
      required 
    />
  </div>

  <div className="form-group">
    <label htmlFor="textarea">How Can We Help You?</label>
    <textarea 
      className="textarea" 
      id="textarea" 
      rows="10" 
      cols="50" 
      placeholder="Write your Message"   
      name="message"
      value={form.message}
      onChange={handleChange} 
      required 
    />
  </div>
<div className='flex justify-center'>

  <button
              className="group inline-block rounded-full bg-gradient-to-r from-[#ffff00] via-[#ffff00] to-yellow-500 p-[2px] hover:text-white"
              href="#contact"
              type="submit"
              >
              <span className="block rounded-full bg-white px-6 py-2 sm:px-8 sm:py-3 text-sm group-hover:bg-transparent text-black font-bold">
              {loading ? 'Sending...' : 'Send Message'}
              </span>
            </button>
              </div>

  {/* <button type="submit" className="form-submit-btn">
    {loading ? 'Sending...' : 'Send Message'}
  </button> */}
</form>

    </div>

          </motion.div>

        
        </div>
      </section>
    </>
  );
};

export default Contact;